import { useParams, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import Navbar from '../components/Navbar';
import HeroEditorial from '../components/HeroEditorial';
import HeroDashboard from '../components/HeroDashboard';
import HeroSplitCinematic from '../components/HeroSplitCinematic';
import AuthDialog from '../components/AuthDialog';
import { ArrowLeft } from 'lucide-react';

const VARIANTS = {
  a: { name: 'Editorial Studio', Comp: HeroEditorial },
  b: { name: 'Live Dashboard', Comp: HeroDashboard },
  c: { name: 'Split Cinematic + Bento', Comp: HeroSplitCinematic },
};

export default function PreviewPage() {
  const { variant = 'a' } = useParams();
  const navigate = useNavigate();
  const [authOpen, setAuthOpen] = useState(false);
  const chosen = VARIANTS[variant] || VARIANTS.a;
  const Hero = chosen.Comp;

  return (
    <div className="relative">
      {/* Floating variant switcher */}
      <div className="fixed top-4 right-4 z-[100] flex items-center gap-2 px-3 py-2 rounded-full bg-slate-950/85 backdrop-blur-xl border border-white/15 shadow-2xl">
        <button
          data-testid="preview-back"
          onClick={() => navigate('/')}
          className="text-white/70 hover:text-white flex items-center gap-1 text-xs"
        >
          <ArrowLeft size={12} /> Home
        </button>
        <span className="text-white/25 mx-1">|</span>
        {Object.entries(VARIANTS).map(([k, v]) => (
          <button
            key={k}
            data-testid={`preview-switch-${k}`}
            onClick={() => navigate(`/preview/${k}`)}
            className={`px-2.5 py-1 rounded-full text-[11px] font-bold uppercase tracking-widest transition ${
              variant === k
                ? 'bg-gradient-to-r from-cyan-400 to-indigo-500 text-white'
                : 'text-white/60 hover:text-white'
            }`}
          >
            {k}
          </button>
        ))}
      </div>

      {/* Variant label */}
      <div className="fixed top-4 left-4 z-[100] px-3 py-2 rounded-full bg-slate-950/85 backdrop-blur-xl border border-white/15 shadow-2xl text-white text-[11px] tracking-widest uppercase font-bold">
        Option {variant.toUpperCase()} &middot; {chosen.name}
      </div>

      <Navbar onGetStarted={() => setAuthOpen(true)} />
      <Hero onSignIn={() => setAuthOpen(true)} />
      <AuthDialog open={authOpen} onOpenChange={setAuthOpen} />
    </div>
  );
}
